/**
 * Categorizes latency in milliseconds into a quality rating.
 * Thresholds:
 * - < 120ms: Excellent
 * - 120ms - 250ms: Good (typical for cellular mobile hotspot)
 * - 251ms - 600ms: Fair
 * - > 600ms: Poor
 */
export function calculateLatencyQuality(rttMs) {
    if (rttMs === null || rttMs === undefined || isNaN(rttMs) || rttMs < 0) {
        return 'unknown';
    }
    if (rttMs < 120) {
        return 'excellent';
    }
    if (rttMs <= 250) {
        return 'good';
    }
    if (rttMs <= 600) {
        return 'fair';
    }
    return 'poor';
}
//# sourceMappingURL=latency.js.map